import Component from '@glimmer/component';
import { action } from '@ember/object';

const STYLE_LOAD_TIMEOUT_MS = 2000;

export default class PrintThisComponent extends Component {
  @action
  doPrint() {
    const selector = this.args.printSelector;
    const target = selector && document.querySelector(selector);
    if (!target) {
      console.warn(`<PrintThis>: no element matches selector "${selector}"`);
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.style.cssText =
      'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument;
    const headHTML = Array.from(
      document.querySelectorAll('link[rel="stylesheet"], style'),
    )
      .map((el) => el.outerHTML)
      .join('');

    doc.open();
    doc.write(
      `<!doctype html><html><head><meta charset="utf-8">${headHTML}</head><body>${target.outerHTML}</body></html>`,
    );
    doc.close();

    let printed = false;
    const cleanup = () => {
      setTimeout(() => {
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }, 250);
    };
    const triggerPrint = () => {
      if (printed) return;
      printed = true;
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } finally {
        cleanup();
      }
    };

    const links = Array.from(doc.querySelectorAll('link[rel="stylesheet"]'));
    if (links.length === 0) {
      triggerPrint();
      return;
    }

    let remaining = links.length;
    const onLoaded = () => {
      remaining -= 1;
      if (remaining === 0) triggerPrint();
    };
    for (const link of links) {
      try {
        if (link.sheet && link.sheet.cssRules) {
          onLoaded();
          continue;
        }
      } catch (_) {
        onLoaded();
        continue;
      }
      link.addEventListener('load', onLoaded, { once: true });
      link.addEventListener('error', onLoaded, { once: true });
    }
    setTimeout(triggerPrint, STYLE_LOAD_TIMEOUT_MS);
  }
}
